import { Icon, Button, Text } from "@chakra-ui/react";
import { IconType } from "react-icons/lib";

export interface FooterIconProps {
  iconText?: string | number;
  width?: string | number;
  height?: string | number;
  iconAriaLabel?: string;
  testIdFooterIcon?: string;
  testIdCountText?: string;
  hideIconText?: boolean;
  icon?: IconType;
  onClick?(): any;
  isVoteActive?: boolean;
  isVoteDisabled?: boolean;
  isIconButtonPressed?: boolean;
}

export function FooterIcon(props: FooterIconProps) {
  const {
    iconText,
    icon,
    iconAriaLabel,
    width,
    height,
    onClick,
    hideIconText,
    testIdFooterIcon,
    testIdCountText,
    isVoteActive,
    isVoteDisabled,
    isIconButtonPressed
  } = props;

  return (
    <Button
      display="flex"
      variant="tertiary"
      justifyContent="center"
      onClick={onClick}
      h={4}
      gap={2}
      p={3}
      fontWeight={500}
      data-testid="card-footerButton"
      isActive={isVoteActive}
      backgroundColor="transparent"
      isDisabled={isVoteDisabled}
      aria-label={iconAriaLabel}
      aria-pressed={isIconButtonPressed}
    >
      <Icon
        justifySelf="flex-start"
        w={width ? width : 4}
        h={height ? height : 4}
        as={icon}
        data-testid={testIdFooterIcon}
      />
      {iconText && (
        <Text
          fontWeight="medium"
          fontSize="xs"
          hidden={hideIconText}
          data-testid={testIdCountText}
        >
          {iconText}
        </Text>
      )}
    </Button>
  );
}
